export const GLOBAL_INTERACTION = "global.interaction";
export const CITRUS_AD_CLICK = "citrusAd.clicked";
export const KEVEL_AD_CLICK = "kevel.clicked";
export const ANALYTICS_JLDATA_UPDATED = "JlDataUpdateComplete";
export const ADD_TO_BASKET = "plp.addToBasket";
export const VIEW_GIFT_MESSAGES = "product-list.gift-messages.show";
export const REMOVE_PRODUCT = "product-list.remove-product";
export const WISHLIST_ADD_TO_BASKET = "product-list.wishlist.add-to-basket";
export const WISHLIST_GIFT_MESSAGE = "product-list.wishlist.gift-message";
export const WISHLIST_GIFT_MESSAGE_SUCCESS =
  "jl-events.browser.giftMessageSuccess";
export const WISHLIST_GIFT_MESSAGE_ERROR = "jl-events.browser.giftMessageError";
